import { all } from "redux-saga/effects";

import { adminCasesSaga } from "shared/sagas/adminCasesSaga";
import { adminPatientSaga } from "shared/sagas/adminPatientSaga";
import { authSaga } from "shared/sagas/authSaga";
import { messagesSaga } from "shared/sagas/messagesSaga";
import { generateAsyncSagas } from "shared/utils/asyncActions";

import { qrLoginSaga } from "./qrLoginSaga";

// Import files which create Sagas with createAsyncSaga()
import "app/reducers/admin/actions/caseActions";
import "app/reducers/admin/actions/patientActions";
import "app/reducers/admin/actions/specimensActions";
import "shared/actions/authActions";
import "shared/actions/sysActions";
import "shared/actions/frontLoaderActions";
import "app/actions/accessionActions";
import "app/actions/caseActions";
import "app/actions/workActions";
import "app/actions/documentActions";
import "app/actions/specimenActions";
import "app/actions/blockActions";
import "app/actions/slideActions";

export default function* rootSaga() {
  yield all([
    authSaga(),
    qrLoginSaga(),
    adminCasesSaga(),
    adminPatientSaga(),
    messagesSaga(),
    ...generateAsyncSagas(),
  ]);
}
